module.exports = __webpack_public_path__ + "static/09-digital-surface-map-7cc796b79905d40fb588c941363a831d.png";